<ideal-wire-cut-custom-length-view
  [formControl]="internalControl"
  [pricing]="pricing()"
  [conflicted]="conflicted()"
  [mode]="mode()"
  (lengthEnter)="lengthEnter.emit()"
  (quantityEnter)="quantityEnter.emit()"
  (deleteRequested)="deleteRequested.emit()"
/>
